module.exports = __webpack_public_path__ + "img/reception-success.18e1b876.svg";